/**
 * @file Defines the {@link PaytableSection} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Paytable section class */
 export class PaytableSection {

    /**
     * Config for paytable section
     * @memberof PaytableSection
     * @private
     * @instance
     * @type {object}
     */
    _config

    /**
     * Reference to paytable section node
     * @memberof PaytableSection
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _elem

    /**
     * Page node of paytable section
     * @memberof PaytableSection
     * @private
     * @instance
     * @type {HTMLElement}
     */
    _page

    /**
     * Config of paytable section
     * @param {object} config_ - Paytable section config
     * @param {object} page_   - Paytable page node
     */
    constructor(config_, page_) {

      this._config = config_  //Store paytable section config
      this._page   = page_    //Store reference to paytable page node

    }

 }